export const commonSelectRowMixin = {
  data() {
    return {
      selectedItems:[],
      lastCheckedIndex: null,
      selectRowItemKey: 'id'
    };
  },
  methods: {
      selectAllRows(e) {
        if(e.target.checked){
          this.selectedItems = this.pageData.data.map(item => item[this.selectRowItemKey]);
        }else{
          this.selectedItems = []
        }
      },
      handleCheckboxClick(event, item) {
          const currentIndex = this.pageData.data.findIndex(
            i => i[this.selectRowItemKey] === item[this.selectRowItemKey]
          );
          if (this.lastCheckedIndex !== null && event.shiftKey) {
            let start = Math.min(this.lastCheckedIndex, currentIndex);
            let end = Math.max(this.lastCheckedIndex, currentIndex);
  
            for (let i = start; i <= end; i++) {
              const itemId = this.pageData.data[i][this.selectRowItemKey];
              if (!this.selectedItems.includes(itemId)) {
                this.selectedItems.push(itemId);
              }
            }
          } else {
            this.lastCheckedIndex = currentIndex;
          }
      },
      exportSelected() {
        if (!this.selectedItems.length) {
            this.alertError("Select the items you'd like to export."); return;
        }
        const json = this.pageData.data
            .filter(cd => this.selectedItems.includes(cd.id))
            .map(item => {
                return Object.keys(item).reduce((acc, key) => {
                    let formattedKey = key.replace(/_/g, " ") // Optional: Format key names
                        .replace(/\b\w/g, char => char.toUpperCase()); // Capitalize words

                    if (key.includes("_at")) {
                        acc[formattedKey] = this.$filters.date(item[key], 1)
                    } else if (Array.isArray(item[key])) {
                        acc[formattedKey] = JSON.stringify(item[key])
                    } else if (typeof item[key] === 'object' && item[key] !== null) {
                        acc[formattedKey] = this.$filters.formatKeyValue(item[key])
                    } else {
                        acc[formattedKey] = item[key];
                    }
                    return acc;
                }, {});
            })
        const csvString = this.jsonToCSV(json)

        const componentName = this.$options.name || '';
        this.downloadCSV(csvString, `${componentName}_exported_data_${this.$filters.timeToString()}.csv`)
    },
  },
};